export default __webpack_public_path__ + "static/bg-marketing-4c8d63472d1035be007be9f4225a0cce.png";